<div>
    <div class="summary-data-number">{{itemValue}}</div>
</div>
